import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
// import './TabActionButtons.css';

const TabActionButtons = ({ 
  onSave,
  onReset,
  showToast,
  saveLabel,
  resetLabel,
  className = '',
  disabled = false
}) => {
  const [isSaving, setIsSaving] = useState(false);
  const [isResetting, setIsResetting] = useState(false);

  const handleSave = async () => {
    if (isSaving || isResetting || !onSave) return;
    
    setIsSaving(true);
    try {
      await onSave();
    } catch (error) {
      console.error('Save error:', error);
      showToast?.('error', __('Error', 'havenlytics'), error.message || __('Failed to save settings', 'havenlytics'));
    } finally {
      setIsSaving(false);
    }
  };

  const handleReset = async () => {
    if (isSaving || isResetting || !onReset) return;
    
    // Use custom alert for confirmation dialog only
    if (window.HvnlyNabAlert) {
      const confirmed = await window.HvnlyNabAlert.confirm(
        __('Are you sure you want to reset all settings? This cannot be undone.', 'havenlytics'),
        __('Reset Settings?', 'havenlytics')
      );
      
      if (confirmed !== 'confirm') return;
    } else {
      // Fallback to native confirm if custom alert not available
      const confirmed = window.confirm(__('Are you sure you want to reset all settings? This cannot be undone.', 'havenlytics'));
      if (!confirmed) return;
    }
    
    setIsResetting(true);
    try {
      // Call the parent's onReset function and wait for it to complete
      const result = await onReset();
      console.log('TabActionButtons - Reset result:', result);
      // The success toast is handled by the parent component (SettingsApp)
    } catch (error) {
      console.error('Reset error:', error);
      showToast?.('error', __('Error', 'havenlytics'), error.message || __('Failed to reset settings', 'havenlytics'));
    } finally {
      setIsResetting(false);
    }
  };

  return (
    <div className={`hvnly-settings-api__tab-actions ${className}`}>
      <button
        type="button"
        className="hvnly-settings-api__modern-btn hvnly-settings-api__modern-btn--secondary"
        onClick={handleReset}
        disabled={disabled || isSaving || isResetting}
      >
        {isResetting ? (
          <>
            <i className="fas fa-spinner fa-spin"></i>
            <span>{__('Resetting...', 'havenlytics')}</span>
          </>
        ) : (
          <>
            <i className="fas fa-undo"></i>
            <span>{resetLabel || __('Reset Changes', 'havenlytics')}</span>
          </>
        )}
      </button>
      
      <button
        type="button"
        className="hvnly-settings-api__modern-btn hvnly-settings-api__modern-btn--primary"
        onClick={handleSave}
        disabled={disabled || isSaving || isResetting}
      >
        {isSaving ? (
          <>
            <i className="fas fa-spinner fa-spin"></i>
            <span>{__('Saving...', 'havenlytics')}</span>
          </>
        ) : (
          <>
            <i className="fas fa-save"></i>
            <span>{saveLabel || __('Save Settings', 'havenlytics')}</span>
          </>
        )}
      </button>
    </div>
  );
};

export default TabActionButtons;